/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from '@module-logger/mbp';
import {
    dollarAndLettersRegexp,
    functionRegexp,
    equalRegexp,
    andRegexp,
    orRegexp,
    differentRegexp,
    jsonRegexp,
} from '../constants/input';

/**
 * Filter out any potential input injection
 * @param {string} inputString customer message
 */
const inputSanitization = (inputString, conversationId, featureFlags = []) => {
    if (!featureFlags['is-input-sanitization-enabled-pwa']) {
        return inputString;
    }
    let sanitizedInput = inputString;
    const regexpList = [
        dollarAndLettersRegexp,
        functionRegexp,
        equalRegexp,
        andRegexp,
        orRegexp,
        differentRegexp,
        jsonRegexp,
    ];

    regexpList.forEach((regex) => { sanitizedInput = sanitizedInput.replace(regex, ''); });

    if (inputString !== sanitizedInput) {
        mbpLogger.logWarning({
            appName: process.env.npm_package_name,
            function: 'inputHelper.inputSanitization',
            component: 'inputHelper.js',
            message: `Possible Input Injection detected: ${inputString}`,
            conversationId,
        });
    }
    return sanitizedInput;
};

export default inputSanitization;
